module.exports = __webpack_public_path__ + "static/media/menu-icon-back.2d59395c.png";